import React, { useCallback, useRef, useState, createRef } from 'react';
import config from './config.json';
// import { api, APIS } from '@/api';
import { message, Button, Input, Modal } from 'antd';
// import { modalAddOrEditFn } from './components/addOrEdit';
import { AddOrEditForm } from './components/addOrEdit';
import { SActionBtn, SBack, SLowcodeList, STableActions, SDrawer } from 'shj-components'
import { finAccountPageList, finAccountPageOption, finAccountPageSaveOrUpdate, acquireFinAccountBatchFromKd } from '@/services/fmsConfig'
import { httpCompanyList } from '@/services/fmsServices'
// 定义接口类型
interface AccountRecord {
  id: string;
  enabled: boolean;
  [key: string]: any;
}

interface ExtensionProps {
  selectedRowKeys?: string[];
  record?: AccountRecord;
  rows?: AccountRecord[];
  selectedRows?: AccountRecord[];
}

export default function FinancialAccountManagement() {  // 给组件明确的名称
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  const [statusLoading, setStatusLoading] = useState<string[]>([]);  // 存储正在切换状态的行 id
  const [editData, setEditData] = useState<any>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  // 新增同步金蝶银行相关状态
  const [syncVisible, setSyncVisible] = useState(false);
  const [cardNoStr, setCardNoStr] = useState('');
  const [syncLoading, setSyncLoading] = useState(false);
  // 将API调用统一处理
  const fetchList = useCallback(async (values: any) => {
    const { current, pageSize, ...rest } = values;
    try {
      const { records, total } = await finAccountPageList(current, pageSize, rest.query);
      return { records, total };
    } catch (e) {
      return { success: false };
    }
  }, []);

  // 简化状态切换逻辑
  const toggleAccountStatus = useCallback(async (ids: string[], state: boolean) => {
    setStatusLoading(prev => [...prev, ...ids]);
    try {
      const response = await finAccountPageOption({ ids, state });
      message.success(response?.message || '操作成功');
      listRef.current?.reload();
    } catch (error) {
      // message.error('操作失败');
    } finally {
      setStatusLoading(prev => prev.filter(id => !ids.includes(id)));
    }
  }, []);

  const handleStatusChange = useCallback((selectedRows: AccountRecord[], state: boolean) => {
    const ids = selectedRows.map(row => row.id);
    toggleAccountStatus(ids, state);
  }, [toggleAccountStatus]);
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  // 新增
  const add = () => {
    setOpen(true)
    setEditData(null)
    // const {
    //   current: { reload },
    // } = listRef;
    // modalAddOrEditFn({
    //   fn: () => {
    //     reload();
    //   },
    //   ...obj,
    // });
  };
  const edit = (obj: object) => {
    setOpen(true)
    setEditData(obj)
  };

  const onSave = useCallback((values, dialogDestroy) => { }, []);

  const onAdd = useCallback(() => {
    add();
  }, [onSave]);

  const onEdit = useCallback(
    (record) => {
      edit(record);
    },
    [onSave],
  );
  const onSubmitOk = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      setSubmitLoading(true);
      finAccountPageSaveOrUpdate({ ...values, overPickAccount: values.overPickAccount ? 1 : 0, companyPaymentAccountFlag: values.companyPaymentAccountFlag ? 1 : 0, onlinePaymentAccount: values.onlinePaymentAccount ? 1 : 0, }).then((resp: any) => {
        setSubmitLoading(false);
        setOpen(false)
        message.info(resp?.message || '保存成功');
        reloadFn()
      })
        .finally(() => {
          setSubmitLoading(false);
        });
    })
  };
  const onSyncK3Bank = () => {
    setSyncVisible(true);
  };
  const handleSync = async () => {
    if (!cardNoStr.trim()) {
      message.warning('请输入银行账号');
      return;
    }
    setSyncLoading(true);
    try {
      const response = await acquireFinAccountBatchFromKd({ cardNoStr });
      message.open({
       type: 'info',
       content: response?.msgStr || '同步成功',
       duration: 8,
      });
      listRef.current?.reload();
      setSyncVisible(false);
      setCardNoStr('');
    } catch (error) {
      message.error('同步失败');
    } finally {
      setSyncLoading(false);
    }
  };
  const extension = {
    request: {
      fetchList,
      getStatusOptions: useCallback(async () => {
        const orgCompanyList = await httpCompanyList();
        return { companyArr: orgCompanyList };
      }, [])
    },
    events: {
      onAdd,
      onSyncK3Bank,
      onEnables: ({ selectedRows }: ExtensionProps) =>
        selectedRows && handleStatusChange(selectedRows, true),
      onDisables: ({ selectedRows }: ExtensionProps) =>
        selectedRows && handleStatusChange(selectedRows, false),
      onEnableChange: (checked: boolean, record: AccountRecord) =>
        handleStatusChange([record], checked)
    },
    status: {
      btnDisabled: ({ selectedRowKeys = [] }: ExtensionProps) => selectedRowKeys.length <= 0,
    },
    customRender: {
      statusCell: (text: any) => text ? '启用' : '禁用',
      overPickAccountText: (text: any) => text == '1' ? '是' : '否',
      renderOperate: (text: string, record: AccountRecord) => (
        <div className="actionBox">
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn
              loading={statusLoading.includes(record.id)}
              onClick={() => handleStatusChange([record], !record.enabled)}
            >
              {record?.enabled ? '禁用' : '启用'}
            </SActionBtn>
          </STableActions>
        </div>
      ),
    },
  };

  return (
    <>
      <SBack title="银行账户管理" />
      <SLowcodeList
        config={config}
        ref={listRef}
        {...extension}
        searchMode="group"
      />
      <Modal
        title="同步金蝶银行"
        visible={syncVisible}
        onOk={handleSync}
        onCancel={() => setSyncVisible(false)}
        confirmLoading={syncLoading}
      >
        <Input.TextArea
          placeholder="请输入银行账号，多个账号用逗号分隔"
          value={cardNoStr}
          onChange={(e) => setCardNoStr(e.target.value)}
          rows={4}
        />
      </Modal>
      <SDrawer
        title={editData?.id ? '编辑' : '新增'}
        width="50%"
        isHideResetBtn={false}
        open={open}
        footer={[
          <Button onClick={() => setOpen(false)}>取消</Button>,
          <Button type='primary' style={{ marginLeft: 10 }} loading={submitLoading} onClick={onSubmitOk}>提交</Button>
        ]}
        onClose={() => setOpen(false)}
        destroyOnClose
      >
        <AddOrEditForm ref={childRef} editData={editData} />
      </SDrawer>
    </>
  );
}
